export { default } from './LeilaoDeVeiculosDatas';
